export const Colors = {
  background: {
    header: '#ffffff',
    DEFAULT: '#ffffff',
    gradient: '#F7F9FE',
    variant: '#F7F9FE',
    grey: '#F7F9FE',
    dark: '#F7F9FE',
  },
  headerIcons: '#000000',
  cardBackground: '#F7F9FE',
  foreground: '#000000',
  section: '#FFF0F5',
  footer: '#FF69B4',
  primary: {
    DEFAULT: '#FF69B4',
    hover: '#FF1493',
    text: '#FF69B4',
    foreground: '#ffffff',
  },
  secondary: {
    DEFAULT: '#FF0080',
    hover: '#FAAD14',
    text: '#FFB6C1',
    foreground: '#ffffff',
    variant: '#FFB6C1',
  },
  tertiary: {
    DEFAULT: '#FF69B4',
    hover: '#FF1493',
    text: '#FF69B4',
    foreground: '#ffffff',
    variant: '#FFB6C1',
  },
  success: '#22c55e',
  error: '#ef4444',
  accent: {
    DEFAULT: '#FF69B4',
    foreground: '#000000',
  },
};
